import React from 'react'

const GuardadorDatos = () => {
  return (
    <div>
      Guardador de datos
    </div>
  )
}

export default GuardadorDatos
